/** @file The args an analysis is sent with: the form's args, plus pivot hints for fns that take them (X1). */
import { actionOf } from './actionOf';
import type { AnalysisRequest } from './autorigTypes';

/** Pivots go only to fns whose action says `pivots: true`, and only when at least one hint is set. */
export function analysisArgs(request: AnalysisRequest): Record<string, unknown> {
  const withPivots = actionOf(request.fn).pivots && Object.keys(request.pivots).length > 0;
  return withPivots ? { ...request.args, pivots: request.pivots } : { ...request.args };
}
